import { useTranslation } from 'react-i18next';
import { ButtonPropsWithLabel } from 'src/components/Dialog';

import { BlockingReasonRow } from './BlockingReasonRow';
import { BlockingReasonVariant } from './_types';
import { blockingReasonTranslationKey } from './blockingReasonTranslationKey';

export function CustomBlockingReason({
  actions,
  title,
  message,
  resolved = false,
  variant = 'checkin',
}: {
  actions?: ButtonPropsWithLabel[];
  title?: string;
  message?: string;
  resolved?: boolean;
  variant?: BlockingReasonVariant;
}) {
  const { t } = useTranslation('translation', { keyPrefix: 'checkinBlocker' });

  return (
    <BlockingReasonRow
      title={
        title || t(blockingReasonTranslationKey(variant, 'custom', 'title'))
      }
      message={
        message || t(blockingReasonTranslationKey(variant, 'custom', 'message'))
      }
      actions={resolved ? undefined : actions}
      color={resolved ? 'success' : 'error'}
    />
  );
}
